"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledInput = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _textField = _interopRequireDefault(require("./textField.proptypes"));

var _constant = require("./constant");

var _excluded = ["children"];

var _inputWrapperVariants;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "TextField__Wrapper",
  componentId: "sc-rcww58-0"
})(["display:flex;flex-direction:column;width:100%;"]);

var inputWrapperVariants = (_inputWrapperVariants = {}, (0, _defineProperty2.default)(_inputWrapperVariants, _constant.INPUT_VARIANT.focused, (0, _styledComponents.css)(["background:", ";border-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary;
})), (0, _defineProperty2.default)(_inputWrapperVariants, _constant.INPUT_VARIANT.error, (0, _styledComponents.css)(["border-color:", ";&:hover{border-color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.orange;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.orange;
})), (0, _defineProperty2.default)(_inputWrapperVariants, _constant.INPUT_VARIANT.disabled, (0, _styledComponents.css)(["background-color:", ";&:hover{background:", ";border-color:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyLighter;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyLighter;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyLight;
})), _inputWrapperVariants);

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextField__InputWrapper",
  componentId: "sc-rcww58-1"
})(function (_ref8) {
  var variant = _ref8.variant,
      borderRadius = _ref8.borderRadius,
      boxSizing = _ref8.boxSizing;
  return (0, _styledComponents.css)(["position:relative;border:", ";box-sizing:", ";border-radius:", ";border-color:", ";background-color:", ";height:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;&:hover{background:", ";border-color:", ";}font-weight:", ";", ""], function (props) {
    return props.hideBorder ? '' : '1px solid';
  }, boxSizing || 'border-box', function (_ref9) {
    var theme = _ref9.theme;
    return borderRadius || theme.borderRadius.normal;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.greyLight;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.default;
  }, function (_ref12) {
    var theme = _ref12.theme,
        variableHeight = _ref12.variableHeight;
    return variableHeight || theme.space.large;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.default;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.secondary;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.fontWeight.normal;
  }, variant && inputWrapperVariants[variant]);
});

InputWrapper.displayName = 'InputWrapper';

var InputContent = _styledComponents.default.div.withConfig({
  displayName: "TextField__InputContent",
  componentId: "sc-rcww58-2"
})(["display:flex;width:100%;flex-direction:column;justify-content:center;", ""], function (_ref16) {
  var alignContentRight = _ref16.alignContentRight;
  return alignContentRight && (0, _styledComponents.css)(["align-items:flex-end;"]);
});

var PrefixContainer = _styledComponents.default.div.withConfig({
  displayName: "TextField__PrefixContainer",
  componentId: "sc-rcww58-3"
})(["align-items:center;box-sizing:border-box;color:", ";display:flex;font-family:", ";font-size:", ";padding:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.greyDark;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontFamily.default;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSize.normal;
}, function (_ref20) {
  var theme = _ref20.theme;
  return "".concat(theme.space.normal, " 0 0 ").concat(theme.space.XXXSmall);
});

var InputContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextField__InputContentWrapper",
  componentId: "sc-rcww58-4"
})(["display:flex;", ""], function (_ref21) {
  var alignContentRight = _ref21.alignContentRight;
  return alignContentRight && (0, _styledComponents.css)(["justify-content:flex-end;"]);
});

var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "TextField__StyledInput",
  componentId: "sc-rcww58-5"
})(["background:transparent;border:none;margin:auto;box-sizing:border-box;border-radius:5px;height:46px;width:100%;outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:", ";font-family:", ";line-height:", ";color:", ";text-indent:", ";", ";&::placeholder{color:", ";opacity:0.5;}&:disabled{background-color:", ";}&[type='number']{-moz-appearance:textfield;}&[type='number']::-webkit-inner-spin-button,&[type='number']::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}&:focus,&:-webkit-autofill{padding:", ";&::placeholder{padding:", ";}}", ""], function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontSize.normal;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontFamily.default;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.lineHeight.normal;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.neutral;
}, function (_ref26) {
  var theme = _ref26.theme,
      prefixed = _ref26.prefixed;
  return prefixed ? theme.space.none : theme.space.XXXSmall;
}, function (_ref27) {
  var alwaysShowLabel = _ref27.alwaysShowLabel,
      theme = _ref27.theme;
  return alwaysShowLabel && "padding: ".concat(theme.space.normal, " ").concat(theme.space.XXXSmall, " 0 0");
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.greyDark;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.greyLighter;
}, function (_ref30) {
  var prefixed = _ref30.prefixed,
      theme = _ref30.theme;
  return prefixed ? "".concat(theme.space.normal, " ").concat(theme.space.XXXSmall, " 0 0;") : "".concat(theme.space.small, " ").concat(theme.space.XXXSmall, " 0 0;");
}, function (_ref31) {
  var theme = _ref31.theme;
  return "".concat(theme.space.none, ";");
}, function (_ref32) {
  var theme = _ref32.theme,
      variant = _ref32.variant,
      hasValue = _ref32.hasValue,
      prefixed = _ref32.prefixed;
  if (variant === _constant.VALIDATE_STATUS_ERROR && !hasValue) return "&::placeholder{ padding: ".concat(theme.space.micro, " ").concat(theme.space.none, "; }");
  if ((variant === _constant.VALIDATE_STATUS_ERROR || variant === _constant.VALIDATE_STATUS_SUCCESS) && hasValue || hasValue) return prefixed ? "padding: ".concat(theme.space.normal, " ").concat(theme.space.XXXSmall, " 0 0;") : "padding: ".concat(theme.space.small, " ").concat(theme.space.XXXSmall, " 0 0;");
  return '';
});

exports.StyledInput = StyledInput;
StyledInput.displayName = 'StyledInput';

var StyledIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextField__StyledIconWrapper",
  componentId: "sc-rcww58-6"
})(["position:absolute;right:", ";"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.space.XSmall;
});

var IconCalendarWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextField__IconCalendarWrapper",
  componentId: "sc-rcww58-7"
})(["padding-top:", ";padding-left:", ";padding-bottom:", ";"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.space.medium;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.space.medium;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.medium;
});

var SmallText = function SmallText(_ref37) {
  var children = _ref37.children,
      rest = (0, _objectWithoutProperties2.default)(_ref37, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    accessible: false,
    type: "small"
  }, rest), children);
};

SmallText.propTypes = {
  children: _propTypes.default.node.isRequired
};
var inputLabelVariants = {
  error: (0, _styledComponents.css)(["color:", ";"], function (_ref38) {
    var theme = _ref38.theme;
    return theme.colors.orange;
  })
};
var inputLabelForHotel = (0, _styledComponents.css)(["top:", ";"], function (_ref39) {
  var theme = _ref39.theme;
  return theme.space.XXXSmall;
});
var InputLabel = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "TextField__InputLabel",
  componentId: "sc-rcww58-8"
})(function (_ref40) {
  var variant = _ref40.variant,
      isOnlyApplyForHotel = _ref40.isOnlyApplyForHotel;
  return (0, _styledComponents.css)(["height:9px;color:", ";line-height:", ";margin-bottom:", ";outline:none;top:", ";position:absolute;padding:0 10px 0;opacity:", ";", ";", ";"], function (_ref41) {
    var theme = _ref41.theme;
    return theme.colors.greyDark;
  }, function (_ref42) {
    var theme = _ref42.theme;
    return theme.lineHeight.XSmall;
  }, function (_ref43) {
    var theme = _ref43.theme,
        labelMarginBottomLarge = _ref43.labelMarginBottomLarge;
    return labelMarginBottomLarge ? theme.space.XXXSmall : theme.space.micro;
  }, function (_ref44) {
    var isDate = _ref44.isDate;
    return isDate ? '4px' : '8px';
  }, variant !== _constant.VALIDATE_STATUS_ERROR ? '0.5' : '', variant && inputLabelVariants[variant], isOnlyApplyForHotel && inputLabelForHotel);
});
InputLabel.displayName = 'InputLabel';
var ErrorMessage = (0, _styledComponents.default)(SmallText).withConfig({
  displayName: "TextField__ErrorMessage",
  componentId: "sc-rcww58-9"
})(["color:", ";"], function (_ref45) {
  var theme = _ref45.theme;
  return theme.colors.orange;
});
ErrorMessage.displayName = 'ErrorMessage';

var TextField = function TextField(props) {
  var propValue = props.value,
      label = props.label,
      icon = props.icon,
      disabled = props.disabled,
      accessible = props.accessible,
      validateStatus = props.validateStatus,
      validateMessage = props.validateMessage,
      selectTextOnFocus = props.selectTextOnFocus,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onClick = props.onClick,
      theme = props.theme,
      customProperties = props.customProperties,
      className = props.className,
      placeholder = props.placeholder,
      InputComponent = props.inputComponent,
      alwaysShowLabel = props.alwaysShowLabel,
      showIconProp = props.showIcon,
      hideBorder = props.hideBorder,
      dayValue = props.day,
      iconFront = props.iconFront,
      variableWidth = props.variableWidth,
      variableHeight = props.variableHeight,
      labelMarginBottomLarge = props.labelMarginBottomLarge,
      alignContentRight = props.alignContentRight,
      gtmEventData = props.gtmEventData,
      fireGtm = props.fireGtm,
      type = props.type,
      prefix = props.prefix,
      forceUpperCase = props.forceUpperCase,
      isOnlyApplyForHotel = props.isOnlyApplyForHotel,
      borderRadius = props.borderRadius,
      innerRef = props.innerRef,
      isDate = props.isDate,
      containerBoxSizing = props.containerBoxSizing;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(propValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      prefixed = _useState6[0],
      setPrefixed = _useState6[1];

  (0, _react.useEffect)(function () {
    setValue(propValue);
  }, [propValue]);
  (0, _react.useEffect)(function () {
    setPrefixed(prefix ? prefix.length > 0 : false);
  }, [prefix]);

  var gtmHandler = function gtmHandler() {
    return fireGtm && gtmEventData ? fireGtm("".concat(gtmEventData), true) : undefined;
  };

  var transformCasing = function transformCasing(newValue) {
    return forceUpperCase ? newValue === null || newValue === void 0 ? void 0 : newValue.toUpperCase() : newValue;
  };

  var handleTextChange = function handleTextChange(event) {
    var newValue = event.target.value;
    setValue(transformCasing(newValue));
    gtmHandler();
    onChange(event);
  };

  var handleFocus = function handleFocus(event) {
    if (selectTextOnFocus) {
      event.target.select();
    }

    setFocused(true);
    onFocus(event);
  };

  var handleBlur = function handleBlur(event) {
    setFocused(false);
    onBlur(event);
  };

  var handleClick = function handleClick() {
    onClick();
  };

  var inputProps = _objectSpread(_objectSpread({
    dayValue: dayValue,
    value: transformCasing(value),
    disabled: disabled,
    placeholder: placeholder || (focused || prefixed ? '' : label),
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleTextChange,
    onClick: handleClick,
    label: label,
    tabIndex: tabIndex,
    className: className,
    variableWidth: variableWidth,
    alignContentRight: alignContentRight
  }, customProperties), {}, {
    isOnlyApplyForHotel: isOnlyApplyForHotel
  });

  var hasValue = type === 'number' ? value !== '' && Number.isFinite(Number(value)) : value;
  var isActive = alwaysShowLabel || focused || hasValue || prefixed;
  var iconName;
  var iconColor;

  if (icon) {
    iconName = icon;
    iconColor = _constant.DEFAULT_ICON_COLOR;
  } else if (validateStatus && _constant.VALIDATE_ICONS[validateStatus]) {
    var _VALIDATE_ICONS$valid = _constant.VALIDATE_ICONS[validateStatus],
        name = _VALIDATE_ICONS$valid.name,
        color = _VALIDATE_ICONS$valid.color;
    iconName = name;
    iconColor = color;
  }

  var shouldShowIcon = !!iconName;
  var variant = '';

  if (disabled) {
    variant = _constant.INPUT_VARIANT.disabled;
  } else if (focused && validateStatus === _constant.VALIDATE_STATUS_ERROR) {
    variant = _constant.INPUT_VARIANT.error;
  } else if (focused) {
    variant = _constant.INPUT_VARIANT.focused;
    shouldShowIcon = icon || false;
  } else if (validateStatus) {
    variant = validateStatus;
  }

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      ref: innerRef
    }, /*#__PURE__*/_react.default.createElement(InputWrapper, {
      borderRadius: borderRadius,
      hideBorder: hideBorder,
      variant: variant,
      variableHeight: variableHeight,
      boxSizing: containerBoxSizing
    }, iconFront && /*#__PURE__*/_react.default.createElement(IconCalendarWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: isOnlyApplyForHotel ? 'greyMediumDark' : '',
      accessible: false,
      icon: iconFront,
      fontsize: "titleNormal"
    })), /*#__PURE__*/_react.default.createElement(InputContent, {
      alignContentRight: alignContentRight
    }, isActive && /*#__PURE__*/_react.default.createElement(InputLabel, {
      labelMarginBottomLarge: labelMarginBottomLarge,
      variant: validateStatus,
      isDate: isDate,
      isOnlyApplyForHotel: isOnlyApplyForHotel
    }, label), /*#__PURE__*/_react.default.createElement(InputContentWrapper, {
      alignContentRight: alignContentRight
    }, prefixed && /*#__PURE__*/_react.default.createElement(PrefixContainer, null, transformCasing(prefix)), InputComponent ? /*#__PURE__*/_react.default.createElement(InputComponent, (0, _extends2.default)({}, inputProps, {
      variant: variant,
      hasValue: hasValue,
      alwaysShowLabel: alwaysShowLabel
    })) : /*#__PURE__*/_react.default.createElement(StyledInput, (0, _extends2.default)({}, inputProps, {
      variant: variant,
      hasValue: hasValue,
      alwaysShowLabel: alwaysShowLabel,
      prefixed: prefixed,
      type: type
    })))), showIconProp && shouldShowIcon && /*#__PURE__*/_react.default.createElement(StyledIconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      icon: iconName,
      color: iconColor,
      fontsize: "titleNormal"
    }))), (validateStatus === _constant.VALIDATE_STATUS_ERROR || validateStatus === _constant.VALIDATE_STATUS_WARNING) && validateMessage && /*#__PURE__*/_react.default.createElement(ErrorMessage, {
      accessible: false
    }, validateMessage));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

TextField.propTypes = _textField.default.PropTypes;
TextField.defaultProps = _textField.default.DefaultProps;
TextField.displayName = 'TextField';
var _default = TextField;
exports.default = _default;